export default {"src":"https://marketing.bounce.com/_next/static/media/shield.7c936e6c.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};